export default "__VITE_ASSET__m1k6dehO__"